import React from "react";
import PropTypes from "prop-types";

// state
import { AppProvider } from "./Context";

// comps
import Filters from "./Filters";
import MediaGrid from "./MediaGrid";

// all the logic of the app is handles in the app context file

const App = ({ filtersTitle, filtersText }) => {
	return (
		<AppProvider>
			<Filters title={filtersTitle} text={filtersText} />
			<MediaGrid/>
		</AppProvider>
	);
};

export default App;

App.propTypes = {
	filtersTitle: PropTypes.string,
	filtersText: PropTypes.string,
};
